import { render } from "./document-view-encrypt.vue?vue&type=template&id=5ad701e8"
import script from "./document-view-encrypt.vue?vue&type=script&lang=js"
export * from "./document-view-encrypt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__